import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'phoneFormat',
  standalone: true
})
export class PhoneFormatPipe implements PipeTransform {

   transform(value: string | null | undefined): string {
    if (!value) return '';
    const cleaned = value.replace(/\D/g, '');
    if (cleaned.length !== 10) return value; // fallback if not 10 digits
    const area = cleaned.slice(0, 3);
    const middle = cleaned.slice(3, 6);
    const last = cleaned.slice(6);
    return `(${area}) ${middle}-${last}`;
  }

}
